<template>
  <div class="info flex">
    <div class="info-logo flex flex-column">
      <img v-if="detail.laboratoryLogo" :src="detail.laboratoryLogo" />
      <img v-else :src="$oss('common/empty-img.png')" />
      <!-- <el-button
        type="primary"
        @click="toCollect"
        size="small"
        plain
        icon="el-icon-star-off"
        >{{ detail.isCollect ? "已" : "" }}收藏</el-button
      > -->
    </div>
    <div class="info-base flex-1">
      <h3>{{ detail.laboratoryName }}</h3>
      <div><label>联系人：</label>{{ detail.laboratoryContactsName }}</div>
      <div>
        <label>电&nbsp;&nbsp;&nbsp;&nbsp;话：</label
        >{{ detail.laboratoryContactsPhone }}
      </div>
      <div>
        <label>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：</label
        >{{ detail.laboratoryEmail }}
      </div>
      <div>
        <label>地&nbsp;&nbsp;&nbsp;&nbsp;址：</label>
        <span>{{ detail.laboratoryLocationProvince }}</span>
        <span>{{ detail.laboratoryLocationCity }}</span>
        <span>{{ detail.laboratoryLocationCounty }}</span>
        <span>{{ detail.laboratoryAddress }}</span>
      </div>
    </div>
    <div
      class="info-qualifications flex flex-column"
      :style="
        qualifications.length && qualifications[0].length > 1
          ? 'width: 300px'
          : 'width: 150px'
      "
      v-if="qualifications.length"
    >
      <el-carousel
        height="110px"
        v-if="qualifications.length && qualifications[0].length > 1"
      >
        <el-carousel-item
          v-for="(item, index) in qualifications"
          :key="`${index}_qualifications`"
        >
          <el-image
            :src="item[0]"
            :preview-src-list="[item[0]]"
            class="info-qualifications-img"
          >
          </el-image>
          <el-image
            v-if="item && item.length > 1"
            :src="item[1]"
            :preview-src-list="[item[1]]"
            class="info-qualifications-img"
          >
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <el-image
        v-else
        :src="qualifications[0][0]"
        :preview-src-list="[qualifications[0][0]]"
        class="info-qualifications-single-img"
      >
      </el-image>
      <p
        :class="
          qualifications.length && qualifications[0].length > 1
            ? 'center-text'
            : 'left-text'
        "
      >
        资质认证
      </p>
    </div>
    <div
      class="info-businessLicence flex flex-column"
      v-if="businessLicence.length"
    >
      <el-image
        v-if="businessLicence && businessLicence.length > 0"
        :src="businessLicence[0]"
        :preview-src-list="[businessLicence[0]]"
        class="info-businessLicence-img"
      >
      </el-image>
      <p class="center-text">营业执照</p>
    </div>
  </div>
</template>
<script>
import { collectSomething, deleteCollect } from "@/api/common";
import { COLLECT_TYPE } from "@/constant/dict";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    businessLicence: {
      type: Array,
      default: () => [],
    },
    qualifications: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async toCollect() {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      const api = this.detail.isCollect ? deleteCollect : collectSomething;
      this.$axios.post(api, {
        collectType: COLLECT_TYPE.laboratory,
        resourceId: this.mainId,
      });
      if (this.detail.isCollect) {
        this.$message.success("已取消收藏");
        const no = 0;
        this.detail.isCollect = no;
      } else {
        this.$message.success("收藏成功");
        const yes = 1;
        this.detail.isCollect = yes;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.info {
  background: #fff;
  padding: 20px;
  &-logo {
    width: 100px;
    img {
      background: #e7e7e7;
      width: 100px;
      height: 100px;
      object-fit: contain;
      margin-bottom: 10px;
    }
  }
  &-base {
    padding-left: 15px;
    font-size: 14px;
    color: $theme-color;
    line-height: 26px;
    h3 {
      font-size: 18px;
      color: #333;
      padding-bottom: 10px;
    }
    label {
      color: #999;
    }
    > div:last-child {
      color: #333;
    }
  }
  &-qualifications {
    padding: 0 15px;
    &-img {
      width: 50%;
      height: 110px;
      background: #e7e7e7;
      ::v-deep img {
        width: 100%;
        object-fit: contain;
      }
      &:last-child {
        border-left: 1px solid #fff;
      }
    }

    &-single-img {
      width: 100%;
      height: 110px;
      background: #e7e7e7;
      ::v-deep img {
        object-fit: contain;
      }
    }
  }
  &-businessLicence {
    width: 160px;
    &-img {
      width: 100%;
      height: 110px;
      background: #e7e7e7;
      ::v-deep img {
        object-fit: contain;
      }
    }
  }

  .center-text {
    padding: 10px 0 0 0;
    text-align: center;
    color: #333;
    font-size: 14px;
  }
  .left-text {
    padding: 10px 0 0 34px;
    text-align: left;
    color: #333;
    font-size: 14px;
  }
}
</style>
